var Resume = /** @class */ (function () {
    function Resume() {
        this.resumeId = null;
        this.sourceTypeId = null;
    }
    return Resume;
}());
export { Resume };
//# sourceMappingURL=resume.js.map